const decodeURL = url => url ? atob(url.replace("/b/", "")) : ""
export default decodeURL
